export default __webpack_public_path__ + "static/media/buspack-login1.612c3710.png";